import { ActionContext, Module } from "vuex";

import { FlagsService } from "@/services";
import { FeaturesReachValueFlags, ViewedFeatureTrialDialogsFlags } from "@/services/DTOs";

export class TrialFeaturesDefinitionState {
  public viewedFeatureTrialDialogsFlags: ViewedFeatureTrialDialogsFlags | undefined;
  public featuresReachValueFlags: FeaturesReachValueFlags | undefined;

  constructor() {
    this.viewedFeatureTrialDialogsFlags = undefined;
    this.featuresReachValueFlags = undefined;
  }

  public updateStateValue(value: [ViewedFeatureTrialDialogsFlags, FeaturesReachValueFlags]) {
    const [viewedFeatureTrialDialogsFlags, featuresReachValueFlags] = value;

    this.viewedFeatureTrialDialogsFlags = viewedFeatureTrialDialogsFlags;
    this.featuresReachValueFlags = featuresReachValueFlags;
  }
}

export default {
  namespaced: true,
  state: () => new TrialFeaturesDefinitionState(),
  mutations: {
    saveTrialFeaturesState(state: TrialFeaturesDefinitionState, data: any) {
      state.updateStateValue(data);
    },
    updateViewedFeatureTrialDialogsFlags(state: TrialFeaturesDefinitionState, data: ViewedFeatureTrialDialogsFlags) {
      state.viewedFeatureTrialDialogsFlags = { ...state.viewedFeatureTrialDialogsFlags, ...data };
    }
  },
  actions: {
    async init(context: ActionContext<TrialFeaturesDefinitionState, any>, opportunityId: string): Promise<void> {
      const getMemberTrialFeatureViewedFlagsPromise = FlagsService.getMemberTrialFeatureViewedFlags(opportunityId).toPromise();
      const getFeaturesReachValueFlagsPromise = FlagsService.getDiscoveryFeaturesReachValueFlags().toPromise();

      await Promise.all([getMemberTrialFeatureViewedFlagsPromise, getFeaturesReachValueFlagsPromise])
        .then((data: [ViewedFeatureTrialDialogsFlags, FeaturesReachValueFlags]) => {
          context.commit("saveTrialFeaturesState", data);
        });
    }
  },
  getters: {
    viewedFeatureTrialDialogsFlags: (currentState: TrialFeaturesDefinitionState): ViewedFeatureTrialDialogsFlags | undefined =>
      currentState.viewedFeatureTrialDialogsFlags,
    featuresReachValueFlags: (currentState: TrialFeaturesDefinitionState): FeaturesReachValueFlags | undefined =>
      currentState.featuresReachValueFlags
  }
} as Module<TrialFeaturesDefinitionState, any>;
